// extracted by css-extract-rspack-plugin
export default {"PanelList":"PanelList-module__PanelList__YCtW5","Condensed":"PanelList-module__Condensed__U_Fg8"};